import React from 'react';

const Footer: React.FC = () => {
  return (
    <footer className="app-footer">
      <div className="app-footer-content">
        Powered by EnHomeBuilder
      </div>
    </footer>
  );
};

export default Footer;
